import * as types from './constants';

const initialState = {
  data: {},
  loading: false,
  errors_api: {}
};

const actions = {
  // Create Reimbursement
  [types.CREATE_REIMBURSEMENT_REQUEST]: state => {
    const data = {
      ...state,
      loading: true
    };

    return { ...data };
  },

  [types.CREATE_REIMBURSEMENT_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      data: payload
    };

    return { ...data };
  },

  [types.CREATE_REIMBURSEMENT_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.CREATE_REIMBURSEMENT_RESET]: () => {
    const data = {
      ...initialState
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

